import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import {
    Grid,
    FormControl,
    InputLabel
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    root: {
        flexGrow: 1,
        paddingLeft: '15px'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: "theme.spacing.unit",
        minWidth: 120,
        marginRight: "66px"

},
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {        marginTop: "0px",        width: '100%'    },
    Grid: {
        flexBasis: "14px"
    }
});

const SearchPanel = (props) => {
    const { classes, StartDate, EndDate, airlines, selectChange, serviceType, reactSelectChange,
        onSearch, handleDateChange, user, allLocations, AirportCode,serviceTypesOptions,
         AirlineId} = props;
    return (
        <div>
            <div className={classes.root}>
            <Grid container spacing={24}>
                <Grid item lg={3}>
                    <div className={classNames(classes.airlineSelect, classes.formControl)}>
                        <InlineDatePicker label={'Start Date'} Date={StartDate}  handleDateChange={(date) => handleDateChange(date, 'StartDate')} />
                    </div>
                </Grid>
                <Grid item lg={3}>
                    <div className={classNames(classes.airlineSelect, classes.formControl)}>
                        <InlineDatePicker label={'End Date'} Date={EndDate}  handleDateChange={(date) => handleDateChange(date, 'EndDate')} />
                    </div>
                </Grid>
                <Grid item lg={3}>
                    <FormControl
                        className={classNames(classes.airlineSelect, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Airlines
                        </InputLabel>
                        <AutocompleteSelect
                            options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                            selectedOption={AirlineId}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            // selectLabel={"Airlines"}
                            disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                            name={"AirlineId"}
                        />
                        {/*<Select*/}
                            {/*value={AirlineId}*/}
                            {/*disabled={user.AppRole === appConstants.ROLES.AIRLINE}*/}
                            {/*onChange={selectChange}*/}
                            {/*input={<Input name="airline" id="airline-label-placeholder" />}*/}
                            {/*// displayEmpty*/}
                            {/*name="AirlineId"*/}
                            {/*className={classes.selectEmpty}*/}
                        {/*>*/}
                            {/*<MenuItem value="-1">All Airlines</MenuItem>*/}
                            {/*{airlines.map((option, i) => (*/}
                                {/*<MenuItem*/}
                                    {/*key={i}*/}
                                    {/*value={option.AirlineId}*/}
                                    {/*className={classes.select}*/}
                                {/*>*/}
                                    {/*{option.Airline}*/}
                                {/*</MenuItem>*/}
                            {/*))}*/}
                        {/*</Select>*/}
                    </FormControl>
                </Grid>
                <Grid item lg={3}>
                    <FormControl
                        className={classNames(classes.airlineSelect, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Airports
                        </InputLabel>
                        <AutocompleteSelect
                            options={allLocations.map(option => ({ value: option.Code, label: option.Name }))}
                            selectedOption={AirportCode}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            // selectLabel={"Airports"}
                            disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                            name={"AirportCode"}
                        />
                        {/*<Select*/}
                            {/*value={AirportCode}*/}
                            {/*disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}*/}
                            {/*onChange={selectChange}*/}
                            {/*input={<Input name="departureLocations" id="departureLocations-label-placeholder" />}*/}
                            {/*// displayEmpty*/}
                            {/*name="AirportCode"*/}
                            {/*className={classes.select}*/}
                        {/*>*/}
                            {/*<MenuItem value="-1"> All Airports</MenuItem>*/}
                            {/*{allLocations.map((option, i) => (*/}
                                {/*<MenuItem*/}
                                    {/*key={i}*/}
                                    {/*value={option.Code}*/}
                                    {/*className={classes.select}*/}
                                {/*>*/}
                                    {/*{option.Name}*/}
                                {/*</MenuItem>*/}
                            {/*))}*/}
                        {/*</Select>*/}
                    </FormControl>
                </Grid>
                <Grid item lg={3}>
                    <FormControl
                        className={classNames(classes.airlineSelect, classes.formControl)}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                        Service Type                        
                        </InputLabel>
                        <AutocompleteSelect
                            options={serviceTypesOptions.map(option => ({ value: option.Id, label: option.Name }))}
                            selectedOption={serviceType}
                            handleSelectChange={(e, name) => reactSelectChange(e, name)}
                            name={"serviceType"}
                        />
                    </FormControl>
                </Grid>
                <Grid item lg={2}>
                    <Button color={'regional'} onClick={() => onSearch()}>Search</Button>
                </Grid>
            </Grid>
            </div>
        </div>
    );
};

export default withStyles(styles)(SearchPanel);


// WEBPACK FOOTER //
// ./src/Regional-Views/StatementOfAccount/SearchPanel.js